module.exports = __webpack_public_path__ + "static/media/01.9cafd84b.png";